import React from "react";
import { Link, Outlet } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { CartDrawer } from "@/components/CartDrawer";

export default function PublicShopShell() {
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-surface">
      <header className="sticky top-0 z-40 border-b border-line bg-surface/90 px-5 py-3.5 backdrop-blur-md">
        <div className="mx-auto flex max-w-6xl items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5" data-testid="public-shop-home">
            <img src="/better-days-mark.png" alt="Better Days" className="h-6 w-auto" />
            <span className="text-[15px] font-bold tracking-tight text-ink">Better Days</span>
          </Link>
          <div className="flex items-center gap-5">
            <Link to="/shop" className="hidden text-sm font-semibold text-ink hover:text-brand sm:block" data-testid="nav-shop-link">Shop</Link>
            <Link to="/videos" className="hidden text-sm font-semibold text-ink hover:text-brand sm:block" data-testid="nav-videos">Videos</Link>
            <CartDrawer />
            {user ? (
              <>
                <span className="hidden items-center gap-2 sm:flex" data-testid="public-shop-user">
                  <span className="grid h-8 w-8 place-items-center rounded-full bg-ink text-xs font-bold text-white">
                    {(user.name || user.email || "?").charAt(0).toUpperCase()}
                  </span>
                  <span className="max-w-32 truncate text-sm font-medium text-ink">{user.name || user.email}</span>
                </span>
                <Link to="/app/dashboard" data-testid="public-shop-dashboard"
                  className="rounded-full bg-brand px-4 py-2 text-sm font-semibold text-white transition-transform hover:-translate-y-0.5">
                  Go to app
                </Link>
              </>
            ) : (
              <>
                <Link to="/login" className="text-sm font-semibold text-ink hover:text-brand" data-testid="public-shop-signin">Sign in</Link>
                <Link to="/register" data-testid="public-shop-signup"
                  className="rounded-full bg-brand px-4 py-2 text-sm font-semibold text-white transition-transform hover:-translate-y-0.5">
                  Start free
                </Link>
              </>
            )}
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-6xl p-5 sm:p-8">
        <Outlet />
      </main>

      <footer className="border-t border-line px-5 py-8 text-center text-sm text-muted">
        <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-3 sm:flex-row">
          <span>© {new Date().getFullYear()} Better Days</span>
          <div className="flex items-center gap-5">
            <Link to="/privacy-policy" className="hover:text-ink">Privacy Policy</Link>
            <Link to="/returns-policy" className="hover:text-ink">Returns Policy</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
